import { graphql } from '@graphql/gql';

export const SESSION_DETAIL = graphql(`
  query SESSION_DETAIL(
    $id: ID!
    $qaLimit: Int
    $locale: String
    $virtualAttendee: Boolean
    $enableSessionCapacity: Boolean!
  ) {
    sessionDetail(id: $id, qaLimit: $qaLimit, locale: $locale) {
      id
      name
      description
      start
      end
      enrolled
      participant
      featured
      virtual
      included
      status
      openForRegistration
      openForAttendeeHub
      recommended
      tags
      hasPoll
      category {
        name
      }
      location {
        id
        name
      }
      speakers {
        id
        firstName
        lastName
        company
        email
        title
        biography
        designation
        profileImageUri
        prefix
        socialLinks {
          facebookUrl
          twitterUrl
          linkedInUrl
        }
      }
      webcast {
        id
        eventId
        sessionId
        format
        title
        sourceId
        provider
        meetingId
        details
        links {
          attendee {
            href
            code
          }
          host {
            href
            code
          }
          join {
            href
            code
          }
          recording {
            href
            code
          }
          speaker {
            href
            code
          }
        }
        playerType
        solutionType
        type
        simulatedLive
        onDemandVideo
        player {
          id
          videoId
          videoUrl
          videoThumbnailUrl
          password
          playerTypeProvider
          stream {
            id
            status
            recording {
              id
              status
            }
          }
          duration
          simuliveOffset
        }
      }
      settings {
        eventId
        sessionId
        qaEnabled
        qaCustomTimeFrameEnabled
        qaStartDateTime
        qaEndDateTime
        autoModerationEnabled
        askAnonymouslyEnabled
      }
      customFields {
        id
        name
        value
        type
        plannerSelected
        filterName
      }
      documents {
        id
        name
        uri
        size
        extension
        sortOrder
      }
      chatSettings {
        isEnabled
        timeRange {
          startDate
          endDate
        }
        stream {
          isAvailable
          channelId
          channelType
          readOnly
        }
      }
      feedbackSurvey {
        surveyUrl
        startOffset
        closeDate
        audience
      }
      exhibitors {
        id
        name
        description
        profileLogoId
        profileLogoUrl
        hidden
        featured
        eventSponsor
        sponsorshipLevelId
        sponsorshipLevel {
          rank
          id
          name
        }
      }
      fee @appFeature(feature: "sessionFee") {
        amount
      }
      participationThresholdSettings {
        participationThreshold
        participationLiveOnly
      }
      widgets {
        widgetId
        sessionId
        widgetTitle
        widgetIcon
        code
        updatedAt
      }
      capacity(virtualAttendee: $virtualAttendee) @include(if: $enableSessionCapacity) {
        totalCapacityAvailable
        availableCapacity
        active
      }
      floorPlan @appFeature(feature: "floorPlansEnabled") {
        id
      }
    }
  }
`);
